module.exports = __webpack_public_path__ + "static/usa-flag-882579b0a86f3c499951ee352e04c0d3.svg";